export const example = "example";
